import { useTranslation } from 'react-i18next';
import { DataTableSearchField } from '../../../components/ui/DataTableSearchField';

/** Backend `query` is capped at 255 characters (400 beyond). */
const SEARCH_MAX_LENGTH = 255;

interface UsersSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Global search of the users list. A thin wrapper over the shared `DataTableSearchField`
 * (same look as every datatable search) that supplies the `users` namespace labels.
 */
export function UsersSearchField({ value, onChange }: UsersSearchFieldProps) {
  const { t } = useTranslation('users');

  return (
    <DataTableSearchField
      value={value}
      onChange={onChange}
      placeholder={t('users:search.placeholder')}
      clearLabel={t('users:search.clear')}
      maxLength={SEARCH_MAX_LENGTH}
    />
  );
}
